import { BASE } from '@/config'
import store from '@/store'

// Компоненты и роуты для роли
const MainPageView = () => import('@/views/teacher/MainPageView')
const PassesView = () => import('@/views/teacher/PassesView')
const ReportsView = () => import('@/views/teacher/ReportsView')
const TeacherIndex = () => import('@/views/teacher/Index')
const StudentsView = () => import('@/views/teacher/StudentsView')
const CardsActionsView = () => import('@/views/teacher/CardsActionsView')
const CardsManagementView = () => import('@/views/teacher/CardsManagementView')
const NotificationsView = () => import('@/views/teacher/NotificationsView')

export default {
  path: '/teachers',
  component: TeacherIndex,
  meta: { role: BASE.ROLES.TEACHER },
  children: [
    {
      path: '',
      name: 'MainPageTeacher',
      component: MainPageView,
      meta: { label: 'Главная' }
    },
    {
      path: 'students',
      name: 'StudentsViewTeacher',
      component: StudentsView,
      meta: { label: 'Список учеников' }
    },
    {
      path: 'cards',
      name: 'CardsManagementTeacher',
      component: CardsManagementView,
      meta: { label: 'Карты' }
    },
    {
      path: 'cards-events',
      name: 'CardsActionsViewTeacher',
      component: CardsActionsView,
      meta: { label: 'Работа с картами' }
    },
    {
      path: 'passes',
      name: 'PassesViewTeacher',
      component: PassesView,
      meta: { label: 'История проходов' }
    },
    {
      path: 'notifications',
      name: 'NotificationsTeacher',
      component: NotificationsView,
      meta: { label: 'Уведомления' }
    },
    {
      path: 'reports',
      name: 'ReportsViewTeacher',
      component: ReportsView,
      meta: { label: 'Отчёты' }
    }
  ],
  beforeEnter(to, from, next) {
    const { state: { common: { user: { tokenData }}}} = store
    if (tokenData !== null && !tokenData.is_connected) {
      next({ name: 'NoSchoolConnectedView' })
      return
    }
    next()
  }
}
